import { FC } from "react";
import { Bonuses } from "../Bonuses/Bonuses";
import { Desktop } from "../Container/Desktop";
import { Mobile } from "../Container/Mobile";
import { Discount } from "../Discount/Discount";
import { DiscountProgress } from "../DiscountProgress/DiscountProgress";
import { ManagerItem } from "../ManagerItem/ManagerItem";
import { TextLabel } from "../TextLabel/TextLabel";

import { Article, BoxBonuse, ArticleContainer } from "./ArticleContent.styled";

type Props = {
  design_type?: number;
  addition_position_display: number;
  additions: any[];
  discountProgressValue: string;
  lockBonus: boolean;
};

export const ArticleContent: FC<Props> = ({
  design_type,
  addition_position_display,
  additions,
  discountProgressValue,
  lockBonus,
}) => {
  if (!additions?.length) return <></>;

  const firstProgress = additions.find(
    ({ config }) => config?.typeDiscount === 2
  );

  return (
    <Article addition_position_display={addition_position_display}>
      <Desktop>
        <>
          {firstProgress && (
            <DiscountProgress
              style={{ marginBottom: "10px" }}
              value={discountProgressValue}
            />
          )}
          <ArticleContainer>
            {additions
              .filter(({ type }) => type === 3)
              .map((item) => (
                <ManagerItem key={item.id} {...item} />
              ))}
            <BoxBonuse>
              {additions
                .filter(({ type }) => type !== 3)
                .map((item) => {
                  if (item.type === 2)
                    return (
                      <Discount
                        key={item.id}
                        addition={item}
                        style={{ width: "100%", marginBottom: "10px" }}
                        lockBonus={lockBonus}
                        disabledDecor={true}
                      />
                    );
                  return (
                    <Bonuses
                      key={item.id}
                      addition={item}
                      style={{ width: "100%", marginBottom: "10px" }}
                      lockBonus={lockBonus}
                      disabledDecor={true}
                    />
                  );
                })}
            </BoxBonuse>
            <TextLabel
              style={{
                position: "absolute",
                bottom: "10px",
                backgroundColor: "transparent",
              }}
            />
          </ArticleContainer>
        </>
      </Desktop>

      <Mobile>
        <>
          {additions
            .filter(({ type }) => type === 3)
            .map((item) => (
              <ArticleContainer key={item.id}>
                <ManagerItem {...item} />
              </ArticleContainer>
            ))
            .find((item) => item)}

          {firstProgress &&
            additions.filter(({ type }) => type === 1 || type === 2).length >
              1 && (
              <DiscountProgress
                className="progressArticle"
                value={discountProgressValue}
              />
            )}
        </>
      </Mobile>
    </Article>
  );
};
